import React from "react";
import { Paper, Typography, Box, IconButton } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import colors from "../../../../Constants/colors";
import { iconButtonActive } from "../../../../Constants/buttonStyles";

export default function ApiExamples({
  apiKey,
  verificationToken,
  handleCopy,
  query,
}) {
  // 1️⃣ Shell (curl) example
  const curlCmd = `curl  --no-buffer -X POST "https://app.queryloop.ai/api/developer/use" \\
-H "Content-Type: application/json" \\
-H "apiKey: ${apiKey}" \\
-d '{"query": ${
    query || "What is this about?"
  },"verification_token":"${verificationToken}"}'`;
  // 1️⃣ Shell (curl) example without streaming
  const curlCmdNoStreaming = `curl -X POST "https://app.queryloop.ai/api/developer/use" \\
-H "Content-Type: application/json" \\
-H "apiKey: ${apiKey}" \\
-d '{"query":${
    query || "What is this about?"
  },"verification_token":"${verificationToken}"}'`;

  // 2️⃣ JavaScript fetch() example
  const jsFetch = `fetch("https://app.queryloop.ai/api/developer/use", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "apiKey": "${apiKey}"
  },
  body: JSON.stringify({
    query: "What is this about?",
    verification_token: "${verificationToken}"
  })
})
  .then(res => res.json())
  .then(data => console.log(data))
  .catch(err => console.error(err));`;

  // 3️⃣ Python requests example
  const pyRequests = `import requests

url = "https://app.queryloop.ai/api/developer/use"
headers = {
  "Content-Type": "application/json",
  "apiKey": "${apiKey}"
}
payload = {
  "query": ${query || "What is this about?"},
  "verification_token": "${verificationToken}"
}


with requests.post(url, json=payload, headers=headers, stream=True) as response:
    response.raise_for_status()
    for line in response.iter_lines(decode_unicode=True):
        if line:
            print("Chunk:",line)`;

  // 3️⃣ Python requests example no streaming
  const pyRequestsNoStreaming = `import requests

url = "https://app.queryloop.ai/api/developer/use"
headers = {
  "Content-Type": "application/json",
  "apiKey": "${apiKey}"
}
payload = {
  "query": ${query || "What is this about?"},
  "verification_token": "${verificationToken}"
}

response = requests.post(url, json=payload, headers=headers)
response.raise_for_status()
print(response.status_code)
print(response.text)`;

  const renderExample = (title, instruction, code) => (
    <Paper
      elevation={4}
      sx={{
        backgroundColor: colors.extremeBlue,
        padding: 2,
        mt: 2,
        fontFamily: "'Courier New', Courier, monospace",
        color: colors.extremeWhite,
      }}
    >
      <Typography variant="h6" color={colors.extremeWhite} gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" color={colors.extremeWhite} gutterBottom>
        {instruction}
      </Typography>
      <Typography
        variant="subtitle2"
        color={colors.extremeWhite}
        sx={{
          whiteSpace: "pre-wrap",
          overflowWrap: "break-word",
          wordBreak: "break-all",
          backgroundColor: "rgba(255,255,255,0.1)",
          p: 1,
          borderRadius: 1,
        }}
      >
        {code}
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
        <IconButton
          sx={iconButtonActive}
          onClick={() => handleCopy(code)}
          aria-label="Copy code to clipboard"
        >
          <ContentCopy fontSize="small" />
        </IconButton>
      </Box>
    </Paper>
  );

  return (
    <Box>
      {renderExample(
        "1. Python (requests)",
        "For Python projects, copy this block. It makes the same request and prints the result.",
        pyRequests
      )}
      {renderExample(
        "2. Python (requests) without streaming",
        "For Python projects, copy this block. It makes the same request and prints the result.",
        pyRequestsNoStreaming
      )}
      {renderExample(
        "3. JavaScript (Web Browser or Node)",
        "If you’re building a web page or a Node.js app, copy this snippet into your code to ask Queryloop and handle the response.",
        jsFetch
      )}
      {renderExample(
        "4. Command-Line (curl)",
        "Copy and paste this command into your terminal. It sends your question to Queryloop and shows the answer in your console.",
        curlCmd
      )}
      {renderExample(
        "5. Command-Line (curl without streaming)",
        "Copy and paste this command into your terminal. It sends your question to Queryloop and shows the answer in your console.",
        curlCmdNoStreaming
      )}
    </Box>
  );
}
